import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import Stepper from '../stepper/Stepper';
import ThemeProvider from '@voltmoney/theme';
import { Platform, Pressable, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { getParameters, isFromAndroidWebview } from '../pages/utils';
import { PLATFORM_NAME } from '../pages/constants';
let isFromTdl = false;
let isFromJsSdk;
let hideNeedHelpForTata = false;
if (Platform.OS === 'web') {
    let params = getParameters(window.location.href);
    isFromTdl = params.platform === PLATFORM_NAME.TDL;
    isFromJsSdk = params?.isFromJsSDK || false;
    hideNeedHelpForTata = params.platform === "TATADIGITAL" && isFromJsSdk;
}
const VerificationHeaderBase = ({ id, title, triggerAction, action, onPress, leftCta, leftTitle, leftAction, stepperProps, needHelpIcon, needHelpAction, isFromJupiter, height }) => {
    const theme = ThemeProvider.getTheme();
    const handleLeftAction = () => {
        onPress && onPress();
        leftAction &&
            triggerAction &&
            triggerAction(leftAction);
    };
    const styles = StyleSheet.create({
        container: {
            flexDirection: 'column',
            width: '100%',
            height: height,
            borderRadius: 0,
            borderBottomWidth: 1,
            borderBottomColor: theme.colors[ColorTokens.Grey_Chalk],
            paddingHorizontal: 16,
            paddingVertical: 16,
            backgroundColor: 'white',
            ...Platform.OS === 'ios' && { paddingTop: 24 },
            ...Platform.OS === 'ios' && { paddingTop: 24 },
        },
    });
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(View, { nativeID: id },
                    React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: handleLeftAction, hitSlop: { top: 48, bottom: 48, left: 48, right: 48 } },
                        React.createElement(Icon, { name: IconTokens.BackArrowIcon, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night, action: action, triggerAction: triggerAction }))),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(View, { style: { marginBottom: 3 } },
                    React.createElement(Typography, { label: `${title}`, numberOfLines: 1, fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, fontWeight: '700', fontSize: FontSizeTokens.MD }))),
            leftAction ? (React.createElement(View, { hitSlop: { top: 48, bottom: 48, left: 48, right: 48 }, style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(Icon, { name: IconTokens.Share, size: IconSizeTokens.LG, color: ColorTokens.Primary_100 }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Pressable, { onPress: handleLeftAction },
                    React.createElement(Typography, { ...leftTitle })))) : (React.createElement(React.Fragment, null)),
            needHelpIcon && !hideNeedHelpForTata && (React.createElement(View, { style: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    position: 'absolute',
                    right: 0,
                } },
                React.createElement(TouchableOpacity, { style: {
                        backgroundColor: '#F3F5FC',
                        borderRadius: 24,
                        height: 24,
                        paddingVertical: 3,
                        paddingHorizontal: 8,
                        flexDirection: 'row'
                    }, hitSlop: { top: 48, bottom: 48, left: 48, right: 48 }, onPress: () => {
                        // @ts-ignore
                        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ");
                        if (isFromAndroidWebview() && isFromTdl) {
                            window.open("FAQ_CLICKED", "_parent"); //@ts-ignore
                        }
                        else {
                            needHelpAction();
                        }
                    } },
                    React.createElement(Icon, { name: isFromJupiter || (isFromTdl && isFromJsSdk) ? IconTokens.CONTACT_ICON : IconTokens.Whatsapp, size: IconSizeTokens.MD }),
                    React.createElement(View, { style: {
                            marginLeft: 4
                        } },
                        React.createElement(Typography, { label: 'NEED HELP?', fontSize: FontSizeTokens.XXS, fontWeight: "600", lineHeight: 16, color: ColorTokens.Primary_100, fontFamily: FontFamilyTokens.Inter })))))),
        stepperProps?.data?.length > 1 && React.createElement(View, { style: {
                backgroundColor: 'transparent',
                paddingTop: 12
            } },
            React.createElement(Stepper, { ...stepperProps, type: StepperTypeTokens.HORIZONTAL }))));
};
export default memo(VerificationHeaderBase);
export { VerificationHeaderBase };
